import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import useAuth from "common/hooks/useAuth";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AlertsContext from "common/providers/alerts";
import UserForm from "./UserForm";

function User() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);
  const { user: currentUser, refreshUser } = useAuth();

  const id = router.query.id as string;

  const {
    saveItem,
    updateItem,
    item: otherUser,
    error,
  }: any = useItem("users", id, {
    populate: [
      "avatar",
      "park",
      "role",
      "managers",
      "animals",
      "enclosures",
      "observationGroups",
      "species",
      "sectors",
      "observators",
    ],
  });

  useEffect(() => {
    if (error) {
      setAlert(
        error === "Username already taken"
          ? t("common.usernameAlreadyTaken")
          : error === "Email already taken"
          ? t("common.emailAlreadyTaken")
          : t("common.error"),
        "danger"
      );
    }
  }, [error, setAlert, t]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate("/users");
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataUser: any) => {
      const user = { ...dataUser, name: dataUser.username };

      try {
        if (user.id) {
          await updateItem(user.id, user, false);
        } else {
          await saveItem(user, false);
        }
      } catch (e: any) {
        return e;
      }

      // Un admin peut éditer son propre compte depuis la liste : il faut alors rafraîchir le
      // contexte d'auth, sinon sa langue y reste périmée (cf. MyAccount).
      if (user.id && user.id === currentUser?.id) {
        await refreshUser();
      }

      back();
      return true;
    },
    [updateItem, back, saveItem, currentUser?.id, refreshUser]
  );

  if (id && !otherUser) return null;

  return <UserForm onSubmit={onSubmit} editedUser={otherUser} />;
}

export default User;
